module.exports = __webpack_public_path__ + "HelveticaLightOblique.a127974e91aa0c9c7575.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/HelveticaLightOblique.woff2
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaLightOblique.woff2
// module chunks = styles